import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { MarketplaceGlossary } from "src/app/common/dto/glossary";

export interface GpGlossaries {
  calculationLogic: string;
  datasources: string;
  explanationOfTerms: string;
}

@Injectable({ providedIn: "root" })
export class GpCmsService {
  private readonly http = inject(HttpClient);

  readonly api = "https://cms.climateintelligence.com";

  getGlossaries(): Observable<MarketplaceGlossary> {
    return this.http.get<[GpGlossaries]>(`${this.api}/glossaries?_limit=1&_locale=de`).pipe(
      map(([result]) => MarketplaceGlossary.fromDto(result)),
      catchError(() => of(new MarketplaceGlossary("", "", "")))
    );
  }
}
